import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const addGenericFloatingError = () => FloatingAlertStore.addAlert({
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.errorAlert.payment.title"
  }),
  message: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.errorAlert.payment.text"
  }),
  type: 'danger'
});
export default addGenericFloatingError;